export const OrderCancellationConfigQueryKey = 'orderCancellationConfigs'

export const ProductConfigsQueryKey = 'product-configs'
